import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["scrollContainer"];

  connect() {
    this.storageKey = this.element.dataset.maintainScrollSessionStorage;
    this.container = this.hasScrollContainerTarget ? this.scrollContainerTarget : this.element;

    this.restoreScroll();
    requestAnimationFrame(() => requestAnimationFrame(() => this.restoreScroll()));

    this.onScroll = () => this.saveScrollPosition();
    this.container.addEventListener("scroll", this.onScroll, { passive: true });
  }

  restoreScroll() {
    const stored = sessionStorage.getItem(this.storageKey);
    if (stored !== null) {
      this.container.scrollTop = stored;
    }
  }

  disconnect() {
    if (this.onScroll) {
      this.container.removeEventListener("scroll", this.onScroll);
    }
  }

  saveScrollPosition() {
    if (!this.storageKey) return;
    sessionStorage.setItem(this.storageKey, this.container.scrollTop);
  }
}
